export const ACTION_TRACKER_COLUMNS = [
  "ID",
  "Task",
  "Poam ID",
  "Owner",
  "Due Date",
  "Status",
  "Source",
  // "Source URL",
  "Notes",
  // "Creation Date",
  // "Completion Date"
];

export const ACTION_TABLE_COL_WIDTHS = [
  100, 300, 100, 200, 150, 200, 150, 150, 200, 150, 150,
];

export const HEADER_TABLE_COLS_MAP = {
  ID: "id",
  Task: "task",
  "Poam ID": "risk",
  Owner: "owner",
  "Due Date": "due_date",
  Status: "status",
  Source: "task_type",
  "Source URL": "source_url",
  Notes: "notes",
  // files: string[],
  "Creation Date": "create_date",
  "Completion Date": "completion_date",
};
